import React from 'react';

import { FilterByCategory, FilterByCompany, FilterBySupplier } from 'components';

const Filtering = ({ params }) => {
  return (
    <>
      <FilterByCategory
        fullWidth
        params={params}
        showAsTree
      />
      <FilterBySupplier
        fullWidth
        params={params}
        isMulti
      />
      <FilterByCompany
        fullWidth
        params={params}
        isMulti
      />
    </>
  );
};

export default Filtering;
